import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroller'
import EmptyResult from 'component/EmptyResult'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  gap: var(--category-grid-gap);

  ::-webkit-scrollbar {
    display: none;
  }

  img {
    // UP主頭像圖片位置靠上方以顯示頭部
    object-position: top;
  }
`

export const ScrollWrap = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
`

export const EmptyBox = styled(EmptyResult)`
  height: calc(100% - 2rem);
`

export const ScrollList = styled(InfiniteScroll)`
  display: flex;
  gap: var(--category-grid-gap);
  flex-wrap: wrap;
`
